module.exports = __webpack_public_path__ + "media/Momentum_KnokDoorbell_InstallationVideo_Final_Step7-8.e563b501.mp4";